








































  import { mapGetters, mapActions } from 'vuex'
  import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
  import Question from '../models/Question'
  import SkillItem from '../models/SkillItem'
  import { State, Getter, Action, Mutation } from '../store-helper'
  import { qEditorState } from '../stores'

  @Component({
  })
  export default class SkillItemComponent extends Vue {
    get currentSelectedSkillItem(){
      return qEditorState.currentSelectedSkillItem
    }

    @Prop()
    skillItem: SkillItem

    public skillItemName: string = "";
    public editSkillItem: boolean = false
    public removeSkillItemModal: boolean = false

    public get selected(): boolean {
      return this.currentSelectedSkillItem(this.skillItem.skill.name, this.skillItem.name)
    }

    public set selected(selected: boolean) {
      if (selected) qEditorState.addSelectedSkillItem({skillName: this.skillItem.skill.name, criteria: this.skillItem.criteria, name: this.skillItem.name})
      else qEditorState.removeSelectedSkillItem({skillName: this.skillItem.skill.name, name: this.skillItem.name})
    }

    public editSkillItemToogle(){
      this.skillItemName = this.skillItem.name
      this.editSkillItem = !this.editSkillItem
    }

    public changeSkillItemName(){
      qEditorState.updateSkillItem({skillItem: this.skillItem, params: { name: this.skillItemName }})
      this.editSkillItemToogle()
    }

    public runRemoveSkillItem(){
      qEditorState.removeSkillItem({skillItem: this.skillItem})
      this.removeSkillItemModal = false
    }
  }
